import * as api from '../api';
import * as types from './types';

export const locationIsLoading = (location_id) => {
	return {
		type: types.LOCATION_LOADING,
		location_id
	}
}

export const receiveLocation = (location_id, location, shard) => {
	return {
		type: types.RECEIVE_LOCATION,
		location,
		shard,
		location_id
	}
}

export const locationLoadingError = (location_id) => {
	return {
		type: types.LOCATION_LOADING_ERROR,
		location_id
	}
}

export const loadLocation = (location_id, shard) => {
	return async (dispatch, getState) => {
		if(!getState().locations[location_id]) {
			dispatch(locationIsLoading(location_id, true));

			let data;

			try {
				data = await api.fetchLocation(location_id, shard);
			} catch(e) {
				dispatch(locationLoadingError(location_id, shard));
				return;
			}

			dispatch(receiveLocation(location_id, data, shard));
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/location.js